<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeModal($event)">
      <div class="modal-wrapper" id="wrapper">
        <div class="modal-container">          
          <div class="align-modal"><p><i class="material-icons large-icon">report</i></p>
            <h5>You have <strong>{{votesLeft}}</strong> unused vote(s).</h5>
          </div>

          <div class="align-modal">
            <h6>If you'd like to abstain from using these votes please press 'Next Step' to proceed.</h6>
          </div>
          
          <div class="modal-buttons">
            <button
              class="mdl-button mdl-js-button mdl-button--raised"
              @click="closeModalButton">Go Back
            </button>
            <question-button
              color="primary"
              value="Next Step"
              is-modal="true"
              @button-clicked="trackAbstainAccepted">
            </question-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QuestionButton from '@/components/Questions/QuestionsButton';
import {mapActions} from 'vuex';

export default {
  name: 'AbstainModal',
  components: {
    QuestionButton
  },
  props: {
    questionId: {
      type: [String, Number],
      required: true
    },
    totalVotes: {
      type: Number
    },
    votesLeft: {
      type: Number
    },
    meetingOptions: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
  },
  computed: {
    allVotesRemaining() {
      return this.totalVotes - this.votesLeft === 0;
    }
  },
  methods: {
    ...mapActions('questions', ['updateAbstainOption']),
    // close modal if background is clicked
    closeModal(event) {
      if (event.target.id === 'wrapper') {
        this.$emit('close-modal');
      }
    },
    // Handle modal button closing
    closeModalButton() {
      this.$emit('close-modal');
    },
    trackAbstainAccepted() {
      this.$emit('accept-abstain-modal');

      // if the proxy is disabled, then you choos
      if (this.allVotesRemaining) {
        this.updateSelection('I choose not to vote');
      }
    },
    updateSelection(option) {
      this.updateAbstainOption({
        questionId: this.questionId,
        option: [option]
      });
    }
  },
  data() {
    return {
      path: this.$route.path.split('?')[0]
    };
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 75vw;
  max-height: 80vh;
  margin: 0px auto;
  padding: 5%;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-buttons {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
/* Transitions */
.modal-enter,
.modal-leave {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
